/**
 * Bold Movement — Quick Add to Cart
 * Intercepts forms with [data-bna-form], POSTs to /cart/add.js, updates the
 * cart bubble + cart drawer (Dawn pattern), shows transient button state.
 */
(function () {
  var T = window.BM_I18N || {};
  function tt(s, tok, val){ return String(s).replace(tok, val); }
  function getRoutes() {
    return (window.routes && window.routes.cart_add_url) ? window.routes : { cart_add_url: '/cart/add' };
  }

  function updateCartBubble(itemCount) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]') || bubble;
      span.textContent = itemCount;
    });
    // Header cart link "Bag (N)"
    document.querySelectorAll('.bm-hdr__act[href="/cart"]').forEach(function (a) {
      a.textContent = ((window.BM_I18N && window.BM_I18N.bag) || 'Bag') + ' (' + itemCount + ')';
    });
  }

  function extractSectionInner(html, selector) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderDrawerSections(addedSections) {
    if (!addedSections) return;

    // Cart drawer body: replace #CartDrawer with the freshly-rendered one
    if (addedSections['cart-drawer']) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(addedSections['cart-drawer'], 'text/html');
        var newCartDrawerEl = doc.querySelector('cart-drawer');
        var newInner = newCartDrawerEl ? newCartDrawerEl.querySelector('#CartDrawer') : doc.querySelector('#CartDrawer');
        var oldInner = drawer.querySelector('#CartDrawer');
        if (newInner && oldInner) oldInner.replaceWith(newInner);
        // Drop the is-empty class if cart now has items
        drawer.classList.remove('is-empty');
      }
    }

    // Cart icon bubble: replace innerHTML
    if (addedSections['cart-icon-bubble']) {
      var bubbleEl = document.querySelector('#cart-icon-bubble');
      if (bubbleEl) {
        var bubbleInner = extractSectionInner(addedSections['cart-icon-bubble'], 'div.shopify-section') ||
                          addedSections['cart-icon-bubble'];
        bubbleEl.innerHTML = bubbleInner;
      }
    }
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') drawer.open();
    else drawer.classList.add('active');
    return true;
  }

  function flashButton(btn, state, label) {
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-' + state);
    var textEl = btn.querySelector('.bna__cta-text') || btn;
    var originalLabel = btn.dataset.label || textEl.textContent.trim();
    textEl.textContent = label;
    setTimeout(function () {
      btn.classList.remove('is-' + state);
      textEl.textContent = btn.dataset.original || originalLabel;
      btn.disabled = false;
    }, 1800);
  }

  function attach(form) {
    if (form.dataset.bnaBound === '1') return;
    form.dataset.bnaBound = '1';

    var btn = form.querySelector('button[type="submit"]');
    var textEl = btn && (btn.querySelector('.bna__cta-text') || btn);
    if (btn && textEl) btn.dataset.original = textEl.textContent.trim();

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!btn) return;

      // Bundle quick-pick — bundles (2/3/4/6/10-pack) open a colour picker so the
      // shopper chooses their mix before it's added. Singles fall through to ATC.
      if (window.BM_BUNDLE_QUICKPICK && window.BM_BUNDLE_QUICKPICK.shouldIntercept(form)) {
        if (window.BM_BUNDLE_QUICKPICK.open(form)) return; // picker owns the flow
      }

      // Bundle upgrade intercept — if the modal is loaded and the product is a
      // known solo colorway, defer to the modal instead of straight ATC.
      if (window.BM_UPGRADE_MODAL && window.BM_UPGRADE_MODAL.shouldIntercept(form)) {
        var shown = window.BM_UPGRADE_MODAL.show(form, btn);
        if (shown) return; // Modal owns the flow now
      }

      btn.disabled = true;
      var routes = getRoutes();
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');

      try {
        var res = await fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!res.ok) {
          var errBody = await res.json().catch(function () { return {}; });
          throw new Error(errBody.description || T.addFailed || 'Add to cart failed');
        }

        var added = await res.json();

        // The add response includes rendered sections (we requested them in formData).
        // Replace the cart drawer + icon bubble with fresh markup BEFORE opening,
        // otherwise the drawer pops empty.
        renderDrawerSections(added.sections);

        // Update count fallback (if the bubble section wasn't replaced for some reason)
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        updateCartBubble(cart.item_count);

        flashButton(btn, 'added', 'Added ✓');
        openDrawer();

        // Pixel events
        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            content_ids: [added.product_id],
            content_type: 'product',
            value: added.final_price / 100,
            currency: cart.currency
          });
        }
        if (window.gtag) {
          window.gtag('event', 'add_to_cart', {
            currency: cart.currency,
            value: added.final_price / 100,
            items: [{
              item_id: added.product_id,
              item_name: added.product_title,
              price: added.final_price / 100
            }]
          });
        }
      } catch (err) {
        flashButton(btn, 'error', T.errorRetry || 'Error · Retry');
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-bna-form]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
